import React from "react";
import { Tooltip } from "@mui/material";

// Full text on hover where a cell ellipsizes it, as wide as the cell itself
// (min 200px so a narrow cell doesn't wrap every word). The popper sits above
// the Sprints L3 workspace (same reason as .sl2-status-edit's z-index).
const matchAnchorWidth = {
  name: "matchAnchorWidth",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state }) => { state.styles.popper.width = `${Math.max(state.rects.reference.width, 200)}px`; },
};

// Module-level so the popper isn't rebuilt on every render (Popper re-inits when
// its modifiers array identity changes).
const TITLE_TOOLTIP_SLOT_PROPS = {
  popper: { modifiers: [matchAnchorWidth], sx: { zIndex: 2100 } },
  tooltip: { sx: { maxWidth: "none" } },
};

const TitleTooltip = ({ title, children }) => (
  <Tooltip
    title={title || ""}
    arrow
    enterDelay={100}
    placement="top"
    slotProps={TITLE_TOOLTIP_SLOT_PROPS}
  >
    {children}
  </Tooltip>
);

export default TitleTooltip;